import React from "react";
import Layout from "./Layout";
import { Route, Routes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Solution from "../pages/Solution";
import Feature from "../pages/Feature";
import Pricing from "../pages/Pricing";
import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import Home from "../pages/homepage/Home";
import Form from "../demo/Form";
import BlogPage from "../pages/BlogPage";
import Blogdetail from "../pages/Blogdetail";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Thankyou from "../demo/Thankyou";

const AnimatedRoutes = () => {
  return (
    <>
      <AnimatePresence>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/solution" element={<Solution />} />
            <Route path="/feature" element={<Feature />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/book-your-demo" element={<Form />} />
            <Route path="/blog" element={<BlogPage />} />
            {/* <Route path="/blogdetail"  element={<Blogdetail/>}/> */}
            <Route path="blog/:slug" element={<Blogdetail />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
             <Route path="/thank-you" element={<Thankyou/>} />
          </Route>
        </Routes>
      </AnimatePresence>
    </>
  );
};

export default AnimatedRoutes;
